import config from 'config'
import { $fetch } from 'utils/fetch'
import { getAuthToken } from '../browser/getAuthToken'
import { getOrgId } from '../browser/getOrgId'

export async function uploadVoiceClone(files, voiceName, isAdvancedMode = false, gender) {
  try {
    const formData = new FormData()
    formData.append('name', voiceName)

    if (isAdvancedMode) {
      formData.append('isBeta', 'true')
      gender && formData.append('gender', gender)
    }

    files.forEach((file) => {
      formData.append(`audio_samples`, file)
    })

    if (config.ENV === 'development') {
      // you need to go to server and cd into runtimes/voice-clone , and then run npm run dev to run the local cloudflare worker instance, which automatically points to 8787
      const res = await fetch('http://localhost:8787/v1/voices/clone', {
        method: 'POST',
        body: formData,
        headers: {
          'authorization': `${getAuthToken()}`,
          'x-bland-org-id': getOrgId(),
        },
      })

      const data = await res.json()

      return data
    }

    const { data, errors } = await $fetch('/v1/voices/clone', {
      method: 'POST',
      body: formData,
    })
    if (errors) {
      throw new Error(errors)
    }
    return data
  }
  catch (error) {
    console.error('Error uploading voice clone:', error)
    throw error
  }
}
